var __webpack_exports__ = {};
/*!********************************!*\
  !*** ./src/js/card-forfait.js ***!
  \********************************/
document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", function (event) {
    if (event.target.matches(".card__link-inclusion")) {
      var toggleButton = event.target;
      var targetId = toggleButton.getAttribute("data-target");
      var inclusions = document.getElementById(targetId);
      var content = inclusions.closest(".card__content.inner-content");
      if (inclusions) {
        inclusions.classList.toggle("inclusions-visible");
        content.classList.toggle("content-visible");
      }
    }
  });
});
